import React from 'react';
import ScheduleFilters from '../components/ScheduleFilters';
import {renderFragment} from '../helpers/react-helpers'
import {postJson, resolveRoute} from '../helpers/ajax'
import notify, {notifyError} from '../notify'
import {CustomerBookingsTable} from '../components/CustomerBookingsTable'

export default function ({customerId, showPaymentsColumn, showDriverColumn}: any) {
    renderFragment(<ScheduleFilters/>, '#schedule-filters-container')

    // getDashboardDataTableOptions(resolveRoute('api.dashboardBookings'), {customerId}, {
    //     showPaymentsColumn,
    //     showDriverColumn,
    //     table: '#customer-bookings-table',
    //     storageKey: 'customer'
    // });

    renderFragment(<CustomerBookingsTable {...{customerId,showPaymentsColumn, showDriverColumn}}/>, '#customer-bookings-table')


    document.getElementById('create-login-btn')?.addEventListener('click', ev => {
        ev.preventDefault()
        const btn = ev.currentTarget as HTMLButtonElement
        btn.disabled = true

        postJson<{emails:string[]},{customerId:StringNum}>(resolveRoute('customers.sendCreateLoginEmail'),{
            customerId
        }).then(res => {
            if(res.ok) {
                notify({
                    text: `Sent login instructions to ${res.data.emails.join(', ')}`,
                    className: 'success',
                    timeout: 2000,
                })
            } else {
                notifyError("Server error. Please try again or contact Kymark Support.")
                btn.disabled = false
            }
        }, err => {
            notifyError("Network error. Please check your internet connection and try again.")
            btn.disabled = false
        })
    })

}
